import {
  Autocomplete,
  Checkbox,
  IconButton,
  RadioButtonGroup
} from '@fullscreendigital/carrefour-dex-fe'
import { KeyboardArrowRight } from '@mui/icons-material'
import { Box, FormHelperText, Grid } from '@mui/material'
import { AsyncAutocomplete } from 'components/core-ui/AsyncAutocomplete'
import { Input } from 'components/core-ui/Input'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import sl from '../../../partners.modules.scss'
import { useSelectSearch } from 'hooks/useSelectSearch'
import { ChangeEvent, useEffect, useState } from 'react'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'

const EditPartnerStep = ({
  formik,
  assignmentFormik,
  externalPartnerTypeOptions,
  isPartnerCreation
}) => {
  const [isNewPartner, setIsNewPartner] = useState(true)

  useEffect(() => {
    if (!formik.values.partnerId && formik.values.firstName && formik.values.lastName) {
      setIsNewPartner(true)
    }
  }, [formik.values.partnerId])

  // TODO implement interfaces
  const partnerSelectSearch = useSelectSearch<any, any>({
    url: toTableGETUrl({
      url: '/iam/external-partners/people',
      tableFilters: [
        { name: 'isEnabled', value: true },
        { name: 'activeAssignmentsCount', value: 0 }
      ]
    }),
    searchFields: ['personName', 'email', 'globalId'],
    optionsMap: item => ({
      ...item,
      label: item?.personName,
      value: item?.id
    }),
    initialSearchText: formik.values.partnerId ? formik.values.partnerName || '' : ''
  })

  return (
    <Grid container spacing={2}>
      {!isPartnerCreation && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Autocomplete
                {...partnerSelectSearch}
                label="Partners without active assignments"
                variant="outlined"
                freeSolo
                autoComplete={false}
                filterOptions={x => x}
                value={formik.values.partnerName}
                onChange={(event, value) => {
                  if (value?.id) {
                    const nameParts = (value.personName || '').trim().split(/\s+/)
                    formik.setFieldValue('partnerId', value.id)
                    formik.setFieldValue('partnerName', value.personName)
                    // formik.setFieldValue('externalPartnerType', value.externalPartnerType)
                    formik.setFieldValue('firstName', nameParts[0] || '')
                    formik.setFieldValue('lastName', nameParts.slice(1).join(' '))
                    formik.setFieldValue('email', value.email || '')
                    formik.setFieldValue('phone', '')
                    formik.setFieldValue('emailNotProvided', !value.email)
                    formik.setFieldValue('phoneNotProvided', true)
                  } else {
                    formik.setFieldValue('partnerId', '')
                    formik.setFieldValue('partnerName', value)
                    // formik.setFieldValue('externalPartnerType', '')
                    formik.setFieldValue('firstName', '')
                    formik.setFieldValue('lastName', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('phone', '')
                    formik.setFieldValue('emailNotProvided', false)
                    formik.setFieldValue('phoneNotProvided', false)
                  }
                }}
                onClose={event => {
                  if ((event.target as HTMLInputElement).tagName.toUpperCase() === 'INPUT') {
                    formik.setFieldValue('partnerName', (event.target as HTMLInputElement).value)
                    formik.setFieldValue('partnerId', '')
                    // formik.setFieldValue('externalPartnerType', '')
                    formik.setFieldValue('firstName', '')
                    formik.setFieldValue('lastName', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('phone', '')
                    formik.setFieldValue('emailNotProvided', false)
                    formik.setFieldValue('phoneNotProvided', false)
                  }
                }}
                error={!!formik.errors.partnerName}
                helperText={formik.errors.partnerName as string}
                disabled={isNewPartner}
              />
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', lineHeight: '56px' }}>
              <Box style={{ position: 'relative', left: '16px', top: '6px' }}>
                <Checkbox
                  checked={isNewPartner}
                  label="New Partner"
                  onChange={() => {
                    setIsNewPartner(!isNewPartner)
                    partnerSelectSearch.setSearchText('')
                    formik.setFieldValue('partnerId', null)
                    formik.setFieldValue('partnerName', null)
                    formik.setFieldValue('externalPartnerType', '')
                    formik.setFieldValue('firstName', '')
                    formik.setFieldValue('lastName', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('phone', '')
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <AsyncAutocomplete
              disableClearable
              variant="outlined"
              name="externalPartnerType"
              label="Partner Type"
              value={formik.values.externalPartnerType}
              options={externalPartnerTypeOptions}
              onChange={value => {
                formik.setFieldValue('externalPartnerType', value)
                formik.setFieldValue('extensionPeriod', `${Math.round(value.extensionPeriod / 30)}`)
                assignmentFormik.setFieldValue('store', [])
              }}
              required
              error={!!formik.errors.externalPartnerType}
              helperText={
                (formik.errors.externalPartnerType?.value ||
                  formik.errors.externalPartnerType) as string
              }
            />
          </Grid>
          <Grid item xs={5} style={{ position: 'relative' }}>
            <Box style={{ marginTop: '20px', position: 'absolute', right: '-14px' }}>
              <RadioButtonGroup
                label="Extension period (months)"
                dotStyle
                name="extensionPeriod"
                onChange={(e, option) => formik.setFieldValue('extensionPeriod', option)}
                value={formik.values.extensionPeriod}
                defaultValue={
                  formik.values.externalPartnerType?.label === 'Mandatar'
                    ? formik.initialValues.extensionPeriod
                    : undefined
                }
                row
                disabled={
                  !['Mandatar', 'System', 'Tester'].includes(
                    formik.values.externalPartnerType?.label
                  )
                }
                options={[
                  {
                    label: '1',
                    value: '1'
                  },
                  {
                    label: '3',
                    value: '3'
                  },
                  {
                    label: '6',
                    value: '6'
                  },
                  {
                    label: '12',
                    value: '12'
                  }
                ]}
              />
              {formik.errors.extensionPeriod && (
                <FormHelperText error>{formik.errors.extensionPeriod}</FormHelperText>
              )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="firstName"
          label="First Name"
          width="100%"
          value={formik.values.firstName}
          onChange={formik.handleChange}
          disabled={!isPartnerCreation && (formik.values.partnerId || !isNewPartner)}
          required
          error={!!formik.errors.firstName}
          helperText={formik.errors.firstName as string}
        />
      </Grid>
      <Grid item xs={12}>
        <Input
          type="text"
          variant="outlined"
          name="lastName"
          label="Last Name"
          width="100%"
          value={formik.values.lastName}
          onChange={formik.handleChange}
          disabled={!isPartnerCreation && (formik.values.partnerId || !isNewPartner)}
          required
          error={!!formik.errors.lastName}
          helperText={formik.errors.lastName as string}
        />
      </Grid>
      <Grid item xs={9}>
        <Input
          type="text"
          variant="outlined"
          name="email"
          label="External email"
          width="100%"
          value={formik.values.email}
          onChange={formik.handleChange}
          disabled={formik.values.emailNotProvided}
          required
          error={!!formik.errors.email}
          helperText={formik.errors.email as string}
        />
      </Grid>
      <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', lineHeight: '56px' }}>
        <Box className={sl.checkboxWrapper} style={!!formik.errors.email ? { top: '-6px' } : {}}>
          <Checkbox
            checked={formik.values.emailNotProvided}
            label="Not provided"
            onChange={() => {
              if (!formik.values.emailNotProvided) {
                formik.setFieldValue('email', '')
              }
              formik.setFieldValue('emailNotProvided', !formik.values.emailNotProvided)
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={9}>
        <Input
          type="text"
          variant="outlined"
          name="phone"
          label="Phone"
          width="100%"
          value={formik.values.phone}
          onChange={formik.handleChange}
          required
          disabled={formik.values.phoneNotProvided}
          error={!!formik.errors.phone}
          helperText={formik.errors.phone as string}
        />
      </Grid>
      <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', lineHeight: '56px' }}>
        <Box className={sl.checkboxWrapper} style={!!formik.errors.phone ? { top: '-6px' } : {}}>
          <Checkbox
            checked={formik.values.phoneNotProvided}
            label="Not provided"
            onChange={() => {
              if (!formik.values.phoneNotProvided) {
                formik.setFieldValue('phone', '')
              }
              formik.setFieldValue('phoneNotProvided', !formik.values.phoneNotProvided)
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Input
          type="textarea"
          name="details"
          label="Additional details"
          style={{ width: '100%' }}
          rows={3}
          variant="outlined"
          value={formik.values.details}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            formik.setFieldValue('details', event.currentTarget.value)
          }
          error={!!formik.errors.details}
          helperText={formik.errors.details as string}
        />
      </Grid>
      <Grid item xs={12} className={s.modalButtons}>
        <IconButton
          endIcon={<KeyboardArrowRight />}
          variant="outlined"
          label="Create assignment"
          onClick={() => formik.handleSubmit()}
          style={{ flex: 'none' }}
        />
      </Grid>
    </Grid>
  )
}

export default EditPartnerStep
